import { CSSProperties } from 'react';
import { Chip } from '@mui/material';
import { useI18n } from '@hooks/useI18n/useI18n';
import { ActionPillVariant } from './enums';

interface IActionStatusPillProps {
  label: string;
  small?: boolean;
  variant: ActionPillVariant;
}

interface IVariantStyles extends CSSProperties {
  backgroundColor: string;
  border: string;
  color: string;
}

const defaultStyles: CSSProperties = {
  fontWeight: 'bold',
};

const variants: Record<ActionPillVariant, IVariantStyles> = {
  [ActionPillVariant.Success]: {
    backgroundColor: '#E6F4EA',
    color: '#34A853',
    border: '1px solid #34A853',
  },
  [ActionPillVariant.Neutral]: {
    backgroundColor: '#E8EAED',
    color: '#5F6368',
    border: '1px solid #5F6368',
  },
  [ActionPillVariant.Error]: {
    backgroundColor: '#FFEBEE',
    color: '#EA4335',
    border: '1px solid #EA4335',
  },
};

export const ActionStatusPill = ({
  label,
  small,
  variant,
}: IActionStatusPillProps) => {
  const { translate } = useI18n();
  const style = variants[variant] ?? variants.neutral;
  return (
    <Chip
      label={translate(label)}
      size={small ? 'small' : 'medium'}
      sx={{ ...defaultStyles, ...style }}
    />
  );
};
